import { SchemaV01Adaptor } from './adaptor.js'

/**
 * Default instance for convenience
 */
export const schemaV01Adaptor = new SchemaV01Adaptor()
